@if (groupedData) {
  <div class="drawer-reports">
    @if (IS_TRS_PROJECT) {
      <sag-ui-tabview [value]="selectedReportingPeriod" (change)="changeTab($event)">
        <sag-ui-tab [value]="periodLabel(periods[0]).label" [label]="periodLabel(periods[0]).showLabel"></sag-ui-tab>

        <sag-ui-tab
          [value]="periodLabel(periods[1]).label"
          [label]="periodLabel(periods[1]).showLabel"
          [disabled]="!groupedData[periodLabel(periods[1]).label]"></sag-ui-tab>

        <sag-ui-tab
          [value]="periodLabel(periods[2]).label"
          [label]="periodLabel(periods[2]).showLabel"
          [disabled]="!groupedData[periodLabel(periods[2]).label]"></sag-ui-tab>
      </sag-ui-tabview>
    } @else if (IS_PRODUCT_SAFETY_PROJECT) {
      <sag-ui-tabview [value]="selectedReportingPeriod" (change)="changeTab($event)">
        <sag-ui-tab [value]="periodLabelString(periods[0])" [label]="periods[0]"></sag-ui-tab>

        <sag-ui-tab [value]="periodLabelString(periods[1])" [label]="periods[1]" [disabled]="!groupedData[periodLabelString(periods[1])]"></sag-ui-tab>

        <sag-ui-tab [value]="periodLabelString(periods[2])" [label]="periods[2]" [disabled]="!groupedData[periodLabelString(periods[2])]"></sag-ui-tab>
      </sag-ui-tabview>
    }

    <div class="drawer-report-container">
      @if (groupedData[selectedReportingPeriod]) {
        <mat-tab-group [headerPosition]="" [selectedIndex]="paginator.pageIndex">
          @for (item of groupedData[selectedReportingPeriod]; track item) {
            <mat-tab>
              <app-report-tile (click)="setItem(item)" [item]="item" [showHeader]="false" />
            </mat-tab>
          }
        </mat-tab-group>

        <mat-paginator #paginator [hidePageSize]="true" [length]="groupedData[selectedReportingPeriod].length" [pageSize]="1" />
      } @else {
        <app-report-tile [isPlaceholder]="true" />
      }
    </div>
  </div>
} @else {
  <app-loading-indicator backgroundColor="transparent" size="100px" />
}
